import { render, staticRenderFns } from "./cms-block-table.vue?vue&type=template&id=93fa1926&scoped=true"
import script from "./cms-block-table.vue?vue&type=script&lang=js"
export * from "./cms-block-table.vue?vue&type=script&lang=js"
import style0 from "./cms-block-table.vue?vue&type=style&index=0&id=93fa1926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93fa1926",
  null
  
)

export default component.exports